// removed by extract-text-webpack-plugin
module.exports = {"nrk-sport-logo":"dh-fotballvm18-nrk-sport-logo"};